<template>
  <main class="landing-page" id="landing-page">
    <Background />
    <Navbar class="navbar" />
    <component
      v-for="(component, index) in components"
      :is="landingComponents[component.name]"
      :key="component"
      :content="component.content"
      :id="index === 1 ? 'first-section' : component.name"
    ></component>
    <Footer />
  </main>
</template>

<script setup>
import { deepMap } from "@/utilities/functions/deepMap.js";
import { computed } from "@vue/reactivity";
import Navbar from "../components/Navbar.vue";
import { useI18n } from "vue-i18n";
import Background from "../components/Landing/Background.vue";
import Timeline from "../components/Timeline/Timeline.vue";
import Hero from "../components/Landing/Hero.vue";
import StackedTextSection from "../components/Landing/StackedTextSection.vue";
import TextSectionWithCta from "../components/Landing/TextSectionWithCta.vue";
import DownloadSection from "../components/Landing/DownloadSection.vue";
import VideoPlayer from "../components/Landing/Video/VideoPlayer.vue";
import InfoSection from "../components/Landing/InfoSection.vue";
import Footer from "../components/Footer.vue";

const { tm, rt } = useI18n();

const landingComponents = {
  Hero,
  StackedTextSection,
  TextSectionWithCta,
  DownloadSection,
  VideoPlayer,
  InfoSection,
  Timeline,
};

const components = computed(() => deepMap(tm("landing.components"), rt));
</script>

<style lang="scss" scoped>
//review is deleting the 100vw does anything bad
.landing-page {
  // width: 100vw;
  position: relative;
  overflow: hidden;

  &__background {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
}
</style>
